"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Clock = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c;
    return (react_1.default.createElement("svg", { width: 24 * scale, height: 24 * scale, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M12 6V12L16 14", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Clock;
//# sourceMappingURL=Clock.js.map